import React, { useState } from "react";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { ssnMasking } from "../../utils";
import AddToolTip from "../AddToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import InfiniteScroll from "react-infinite-scroller";

const EmployeeSelectDropdown = (props) => {
  const {
    onClick,
    id,
    optionsList = [],
    title,
    className,
    request,
    setRequest,
    setAppend,
    isLoading,
    value: selectedValue,
    size,
  } = props;
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  return (
    <div className="dropdown-component" style={{ width: "350px" }}>
      <DropdownButton
        alignRight
        title={title}
        id="dropdown-menu-align-bottom"
        className={"dropdown-title"}
      >
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            setAppend(true);
            setRequest({
              ...request,
              from: optionsList?.length,
            });
          }}
          hasMore={!stopInfiniteScroll}
          initialLoad={false}
          threshold={100}
          useWindow={false}
          loader={
            isLoading && (
              <div className="loader" key={0}>
                Loading ...
              </div>
            )
          }
        >
          {optionsList.map(
            ({ value, label, ssn, errorCount, warningCount }, i) => (
              <Dropdown.Item
                key={i}
                onClick={(e) => {
                  let body = {};
                  body = {
                    target: {
                      value: typeof value === "undefined" ? label : value,
                      data: optionsList[i],
                      id: id,
                    },
                  };
                  // this.handleDropdown(id)
                  onClick(body);
                }}
                className={selectedValue === value ? "selected" : ""}
              >
                <div className="d-flex dropdown-option">
                  <div className="d-flex flex-column" style={{ width: "35%" }}>
                    <div style={{ fontWeight: "500", color: "#333333" }}>
                      {<AddToolTip name={label} />}
                    </div>
                    <div className="d-flex justify-content-start">
                      <div className="dark-text align-self-center">
                        {ssnMasking(ssn)}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-row" style={{ width: "65%" }}>
                    <div className="align-self-center vertical-separator"></div>
                    <FontAwesomeIcon
                      style={{ marginTop: "12px" }}
                      color="#A05A06"
                      icon={faCircle}
                    />
                    &nbsp;&nbsp;
                    <div className="align-self-center">
                      <span className="pending-text ft-14 mr-1">
                        {warningCount}
                      </span>
                      Warnings
                    </div>
                    &nbsp;&nbsp;
                    <FontAwesomeIcon
                      style={{ marginTop: "12px" }}
                      color="#C4061A"
                      icon={faCircle}
                    />
                    &nbsp;&nbsp;
                    <div className="align-self-center mr-1">
                      <span className="error-text ft-14 mr-1">
                        {errorCount}
                      </span>
                      Errors
                    </div>
                  </div>
                </div>
              </Dropdown.Item>
            )
          )}
        </InfiniteScroll>
      </DropdownButton>
    </div>
  );
};

export default EmployeeSelectDropdown;
